import { Injectable } from '@angular/core';
import { RequestOptions, Http } from '@angular/http';
import { API_URL, API_eDictate } from '../core/apiconfig';
import { EDictate } from './e-dictate.model';
import { HttpHeader } from '../core/httpheader';

@Injectable()
export class EDictateService {

    private apiUrl: string;

    private requestHeader: HttpHeader = new HttpHeader();
    private Http_Header_Request_Options: RequestOptions;

    constructor(private _http: Http, ) {
        this.apiUrl = API_URL + API_eDictate;
    }

    saveSignature(model: string): Promise<EDictate> {        
        let body = model;
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.put(this.apiUrl + '/SaveeDictate', body, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as EDictate)
            .catch(this.handleError);
    }

    getisValidSign(signatureID: any): Promise<EDictate> {        
        this.Http_Header_Request_Options = this.requestHeader.Http_Header_Request_OptionsTest();
        return this._http.get(this.apiUrl + '/IsValideDictateRequest/' + signatureID, this.Http_Header_Request_Options)
            .toPromise()
            .then(response => response.json() as EDictate)
            .catch(this.handleError);
    }

    // Handle Error

    private handleError(error: any): Promise<any> {
        return
    }
}



// WEBPACK FOOTER //
// ./SignClient/app/e-dictate/e-dictate.service.ts